import { SvgIcon, SvgIconProps } from '@mui/material';
import { memo } from 'react';
const SvgBasket32 = (props: SvgIconProps) => {
  const { sx, ...other } = props;
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      sx={{
        ...sx,
      }}
      {...other}
    >
      <path d="M1.595 3.182.776 29.761h25.801l4.131-3.18-1.99-23.399H1.596zm-.431-.889h27.962c.231 0 .423.177.443.407l2.045 24.048a.444.444 0 0 1-.172.39l-4.443 3.42a.444.444 0 0 1-.271.092H.318a.444.444 0 0 1-.444-.458L.72 2.724a.444.444 0 0 1 .444-.431" />
      <path d="M5.832 6.581c0 4.863 2.787 9.753 7.391 9.753 4.825 0 7.426-4.073 7.426-9.542a.444.444 0 0 0-.888 0c0 5.039-2.308 8.653-6.537 8.653-3.979 0-6.502-4.427-6.502-8.864a.444.444 0 0 0-.888 0zm19.147-3.823 1.305 27.468a.445.445 0 0 0 .888-.042L25.867 2.716a.445.445 0 0 0-.888.042" />
    </SvgIcon>
  );
};
const Memo = memo(SvgBasket32);
export default Memo;
